import { Outlet, useMatch, useOutletContext, useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { LoadingState } from 'modules/processes/components/LoadingState'
import { MaterializedProcess } from 'modules/processes/domain'
import { useMaterializedProcess } from 'modules/processes/hooks/materializedProcess/useMaterializedProcess'
import type { Process } from 'modules/processes/hooks/useProcesses'
import { useProcessContext } from 'modules/processes/pages/Process/ProcessRootPage'
import { useProcessDetail } from 'modules/processes/pages/Process/ProcessRootPage/useProcessDetail'

import MaterializedProcessComponent from './MaterializedProcess'

export const useMaterializedProcessContext = () => {
  return useOutletContext<{
    process: Process
    materializedProcess: MaterializedProcess
    backTo: string
  }>()
}

const MaterializedProcessPage = () => {
  const { materializedProcessId, materializedItemId, category } = useParams()
  const { process: processContext, template } = useProcessContext()

  const { navigation } = useNavigation()

  const { materializedProcess, loading } = useMaterializedProcess({
    id: Number(materializedProcessId),
    includeItemsCount: true,
  })

  const { process, loading: loadingProcess } = useProcessDetail({
    id: processContext.id,
  })

  const showSpinner = !materializedProcessId || !process || loading || loadingProcess

  const isItemPage = !!useMatch({
    path: navigation.processes.template.id.processInstance.item.fullPath({
      category: category as string,
      materializedItemId: materializedItemId as string,
      id: processContext.id,
      materializedProcessId: materializedProcessId as string,
    }),
    end: false,
  })

  if (showSpinner) return <LoadingState />

  return (
    <>
      {!isItemPage && (
        <Box height="full">
          <MaterializedProcessComponent
            process={process}
            materializedProcess={materializedProcess!}
          />
        </Box>
      )}
      <Outlet context={{ process: process, template, materializedProcess }} />
    </>
  )
}

export default MaterializedProcessPage
